// Route configuration — v7
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MembershipBenefits from "../pages/membership-benefits/page";
import PropertyListings from "../pages/property-listings/page";
import CertificateListings from "../pages/certificate-listings/page";
import HowItWorks from "../pages/how-it-works/page";
import Resources from "../pages/resources/page";
import Contact from "../pages/contact/page";
import Pricing from "../pages/pricing/page";
import SignUp from "../pages/signup/page";
import Login from "../pages/login/page";
import ForgotPassword from "../pages/forgot-password/page";
import Dashboard from "../pages/dashboard/page";
import Admin from "../pages/admin/page";

const routes: RouteObject[] = [
  { path: "/",                     element: <Home /> },
  { path: "/membership-benefits",  element: <MembershipBenefits /> },
  { path: "/property-listings",    element: <PropertyListings /> },
  { path: "/certificate-listings", element: <CertificateListings /> },
  { path: "/how-it-works",         element: <HowItWorks /> },
  { path: "/resources",            element: <Resources /> },
  { path: "/pricing",              element: <Pricing /> },
  { path: "/signup",               element: <SignUp /> },
  { path: "/login",                element: <Login /> },
  { path: "/forgot-password",      element: <ForgotPassword /> },
  { path: "/dashboard",            element: <Dashboard /> },
  { path: "/admin",                element: <Admin /> },
  { path: "/contact",              element: <Contact /> },
  { path: "*",                     element: <NotFound /> },
];

export default routes;
